import { RouteTabs } from '../../components/route-tabs';

const adminTabs = [
  { to: '/admin/onboarding', label: 'Onboarding' },
  { to: '/admin/pricing', label: 'Pricing' },
] as const;

export function AdminLayout() {
  return <RouteTabs tabs={adminTabs} color="orange" ariaLabel="Admin Tabs" />;
}
